import { initialState, PerformaceTrackerState } from "./state";
import { Actions } from './actions';
import {
    PERFORMANCE_TRACKER_LIST, PERFORMANCE_TRACKER_BY_ID, SAVE_PERFORMANCE_TRACKER_RESP,
    DELETE_PERFORMANCE_TRACKER_RESP, PERFORMANCE_TRACKER_BY_FIELD_LIST
} from "./actionTypes";
import { SortListAscending } from "app/utils/sort.util";

export function PerformanceTrackerReducer(state = initialState, action: Actions): PerformaceTrackerState {
    switch (action.type) {
        case PERFORMANCE_TRACKER_LIST:
            return Object.assign({}, state, {
                performanceTrackerList: SortListAscending(action.payload, "name")
            });
        case PERFORMANCE_TRACKER_BY_FIELD_LIST:
            return Object.assign({}, state, {
                performanceTrackerByFieldList: SortListAscending(action.payload, "name")
            });
        case PERFORMANCE_TRACKER_BY_ID:
            return Object.assign({}, state, {
                performanceTrackerById: action.payload
            });
        case SAVE_PERFORMANCE_TRACKER_RESP:
            return Object.assign({}, state, {
                savePerformanceTrackerResp: action.payload
            });
        case DELETE_PERFORMANCE_TRACKER_RESP:
            return Object.assign({}, state, {
                deletePerformanceTrackerResp: action.payload
            });
        default:
            return state;
    }
}
